export default "__VITE_ASSET__DY2rf5eJ__"